import merge from 'lodash-es/merge';

import { LabelEnum, PaymentTypeEnum, InstallmentsEnum } from 'app/shared/enums';
import { getOffer, selectGtmOfferName } from 'app/store/data/quotationResult';
import {
  getQuotationNumber,
  selectGtmVehicleType,
} from 'app/store/data/quotation';
import { TagManagerService } from 'app/services/tagManager.service';
import {
  selectCalculationType,
  selectRecommendedOfferType,
  selectSelectedOfferId,
  selectSelectedOfferInsurerName,
} from 'app/store/data/selectedOffer';
import { ThunkResult } from 'app/store/helpers';
import { CheckoutEvent } from 'app/shared/interfaces/CheckoutEvent.interface';

export const addFirstCheckoutStepDataLayer = (): ThunkResult => (
  dispatch,
  getState
) => {
  const state = getState();
  const offerId = selectSelectedOfferId(state);
  const selectedOffer = getOffer(offerId)(state);

  if (offerId === undefined || selectedOffer === undefined) {
    return;
  }

  dispatch(
    markCheckoutStep({
      eventLabel: 'Dane cz. 1',
      ecommerce: {
        checkout: {
          actionField: {
            step: 1,
          },
          products: [
            {
              id: selectedOffer.number,
              name: selectGtmOfferName(offerId, state),
              price: selectedOffer.price.finalPrice,
              brand: selectedOffer.insurerName,
              category: selectGtmVehicleType(state),
              variant: '-',
              quantity: 1,
            },
          ],
        },
      },
    })
  );
};

export const markCheckoutStep = (
  overwrite: Partial<CheckoutEvent> = {}
): ThunkResult => (dispatch, getState) => {
  const state = getState();
  const offerId = selectSelectedOfferId(state);
  const selectedOffer = getOffer(offerId)(state);
  const quotationNumber = getQuotationNumber(state);
  TagManagerService.addDataLayer({
    event: 'clear_ecommerce',
    ecommerce: null,
  });

  if (offerId === undefined || selectedOffer === undefined) {
    return;
  }

  const base: Partial<CheckoutEvent> = {
    event: 'checkout',
    eventCategory: 'ecommerce',
    eventAction: 'checkout',
    numerPorownania: quotationNumber,
    numerOferty: selectedOffer.number,
    typOferty: selectRecommendedOfferType(state),
    typKalkulacji: selectCalculationType(state),
    ecommerce: {
      currencyCode: 'PLN',
      checkout: {
        actionField: { step: 0 },
      },
    },
  };
  TagManagerService.addDataLayer(merge(base, overwrite));
};

export const addInstallmentsModalDataLayerEvent = (
  event: string,
  value?: boolean
): ThunkResult => (dispatch, getState) => {
  const state = getState();
  const offerId = selectSelectedOfferId(state);
  const selectedOffer = getOffer(offerId)(state);
  const quotationNumber = getQuotationNumber(state);

  if (offerId === undefined || selectedOffer === undefined) {
    return;
  }

  TagManagerService.addDataLayer({
    event,
    numer_porownania: quotationNumber,
    nazwa_towarzystwa: selectedOffer.insurerName,
    numer_oferty: selectedOffer.number,
    typ_oferty: selectRecommendedOfferType(state),
    value,
  });
};

export const addPaymentMethodChangeDataLayerEvent = (
  event: string,
  paymentType: string,
  numberOfInstallments: string | number
): ThunkResult => (dispatch, getState) => {
  const state = getState();
  const offerId = selectSelectedOfferId(state);
  const offer = getOffer(offerId)(state);
  const insurerName = selectSelectedOfferInsurerName(state);
  const quotationNumber = getQuotationNumber(state);
  let paymentMethod: string | LabelEnum = LabelEnum.OneTimePayment;

  if (!offer || !numberOfInstallments) {
    return;
  }

  if (paymentType === PaymentTypeEnum.HiProTransfer) {
    paymentMethod = InstallmentsEnum.MubiInstallments;
  } else if (+numberOfInstallments > 1) {
    paymentMethod = `${LabelEnum.InstallmentsFrom} ${insurerName}`;
  }

  const dataLayer = {
    event,
    numer_porownania: quotationNumber,
    nazwa_towarzystwa: offer.insurerName,
    numer_oferty: offer.number,
    typ_oferty: selectRecommendedOfferType(state),
    metoda_platnosci: paymentMethod,
  };

  TagManagerService.addDataLayer(dataLayer);
};
